import { useState, useEffect } from "react";
import styles from "./PaymentMethod.module.scss";
import { useTranslation } from "react-i18next";
import OptionsGroup from "./OptionsGroup";
import _ from "lodash";
import { ReactComponent as FPSLogo } from "../assets/fps_color.svg";
import PayMeLogo from "../assets/payme-logo-red.png";
import StripeLogo from "../assets/stripe.png";

const PaymentMethod = ({ paymentItmeProps, xc }) => {
  const { t } = useTranslation();
  // monthly recurring donations are card-only
  const monthly = paymentItmeProps?.frequency === "monthly";
  return (
    <div className={`${styles["payment-div"]} ${xc}`}>
      <HSBCPaymentItem {...paymentItmeProps} disabled={monthly} />
      <PayMePaymentItem {...paymentItmeProps} disabled={monthly} />
      <StripePaymentItem {...paymentItmeProps} />
      {monthly ? (
        <h5 style={{ color: "#1976d2", width: "100%" }}>每月定期捐款只支援信用卡付款，FPS 及 PayMe 暫不適用於定期捐款。</h5>
      ) : null}
      {window.location.pathname == "/donation" ? (
        <h5>
          注：信用咭公司會在你的捐款中扣除 2.9%(本地)至3.4%(外地) 及PayMe會在你的捐款中扣除 1.5%
          作為他們的行政費用。你或可考慮選擇其他捐款途徑，以讓我們全數收悉你的善款，感恩！
        </h5>
      ) : (
        <h5>
          注：信用咭公司會在你的付款中扣除 2.9%(本地)至3.4%(外地) 及PayMe會在你的付款中扣除 1.5%
          作為他們的行政費用。你或可考慮選擇其他付款途徑，以讓我們全數收悉你的善款，感恩！
        </h5>
      )}
    </div>
  );
};

const disabledStyle = { opacity: 0.35, filter: "grayscale(1)", cursor: "not-allowed" };

const HSBCPaymentItem = ({ paymentMethod, setPaymentMethod, disabled }) => {
  const label = "FPS";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} style={disabled ? disabledStyle : {}} onClick={() => !disabled && setPaymentMethod(label)}>
      <div>
        <FPSLogo />
      </div>
      <p>{label}</p>
    </div>
  );
};

const PayMePaymentItem = ({ paymentMethod, setPaymentMethod, disabled }) => {
  const label = "PayMe";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} style={disabled ? disabledStyle : {}} onClick={() => !disabled && setPaymentMethod(label)}>
      <div style={{ width: "50%", marginTop: 10 }}>
        <img src={PayMeLogo} />
      </div>
      <p>{label}</p>
    </div>
  );
};

const StripePaymentItem = ({ paymentMethod, setPaymentMethod }) => {
  const label = "Card";
  const classes = paymentMethod === label ? "selected" : "";

  return (
    <div className={`${styles["payment-item"]} ${classes}`} onClick={() => setPaymentMethod(label)}>
      <div style={{ width: "50%", marginTop: 10 }}>
        <img src={StripeLogo} width={120} className="centerImage" />
      </div>
      <p>{label}</p>
    </div>
  );
};

export default PaymentMethod;
